(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animatedbannertwo"] && !Shopify.designMode) return;
  try {
    
let current = 0;
const bikes = document.querySelectorAll('.bike');
const buttons = document.querySelectorAll('.bike-btn');
const texts = [
  document.querySelector('.small-text'),
  document.querySelector('.heading'),
  document.querySelector('.subheading'),
  document.querySelector('.extraheading')
];

function cycleBikes() {
  // Reset all
  bikes.forEach((bike, i) => {
    bike.classList.remove('active','exit');
    if (buttons[i]) buttons[i].classList.remove('active');
  });
  texts.forEach(t => t.classList.remove('active','exit'));

  // Previous exit
  let prev = current;
  current = (current + 1) % bikes.length;

  if (bikes[prev]) bikes[prev].classList.add('exit');
  if (texts[prev]) texts[prev].classList.add('exit');

  if (bikes[current]) {
    bikes[current].classList.add('active');
    if (buttons[current]) buttons[current].classList.add('active');
  }

  // Show matching text
  if (texts[current]) texts[current].classList.add('active');
}

// Init first state
if (bikes.length > 0) {
  bikes[0].classList.add('active');
  if (buttons[0]) buttons[0].classList.add('active');
  texts[0].classList.add('active'); // first = small text
  setInterval(cycleBikes, 4000);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }








  

  } catch(e) { console.error(e); }
})();
})();
